<template>

  <div class="navbar-menu">
 
      <b-navbar-item tag="div" style="display:none;">
        <b-button type="is-white" icon-pack="mdi" icon-left="undo" @click="undo" :disabled="!canUndo">Undo</b-button>
        <b-button type="is-white" icon-pack="mdi" icon-right="redo" @click="redo" :disabled="!canRedo">Redo</b-button>
      </b-navbar-item>

      

      <!-- <b-button id="summary-button" @click="showSummary" type="is-dark is-medium" :disabled="!hasConfig" icon-pack="mdi" icon-left="receipt">Summary ({{configurationItems}})</b-button> -->

</div>
 

</template>

<script>
    
  import { mapGetters, mapActions } from "vuex";
  
  import Settings from '@/components/Settings.vue'

  export default {

    name: 'BuildNavigation',

    props: [],

    computed:{

        ...mapGetters(['options','currentUser','getHistory','configuration', 'configurationItems', 'getCurrentViewport','secondaryContent']),

      canUndo(){
          return this.getHistory.mutations.length > 0;
      },

      canRedo(){
          return this.getHistory.removed_mutations.length > 0;
      },

      currentViewport:{
        get(){
          return this.getCurrentViewport;
        },
        set(val){
          this.$store.stage.settings.viewPort = val;
        }
      },

       hasConfig(){
          return this.configuration.length > 0;
      }
    },

    methods:{

      ...mapActions(['undo', 'redo','updateSettings', 'SET_OPTIONS', 'EDIT_ITEM']),

      showSummary(){

          var val = this.secondaryContent != 'summary';

          this.EDIT_ITEM({
              item:{},
              path:[]
          });

          this.SET_OPTIONS({
              showSummary: val
          });
      }
    },

    components:{
      Settings
    }
 
  }
    
</script>

<style scoped>

#summary-button{
  width:165px;
  font-size: 1.1em;
  height:70px;
margin-left: auto;
  justify-self: flex-end;
  border:0;
}



</style>
